import React from 'react'
// context
import { ActionContext } from 'context/index'
// graphql
import { PLAN_ACTION_ACTIVITIES_LIST_QUERY } from 'graphql/planActions/queries'
// types
import { LogEntityTypes } from 'types/graphql'
// view components
import ActivitiesListContainer from 'containers/Activities/components/ActivitiesList'

const ActionActivitiesList: React.FC = () => {
  const { entity } = React.useContext(ActionContext) as any

  const { actionDeleteResource, actionModifyResource } = entity.currentPermissions

  return (
    <ActivitiesListContainer
      canDeleteResource={actionDeleteResource}
      canModifyResource={actionModifyResource}
      entity={{ ...entity, entityType: LogEntityTypes.Action }}
      query={PLAN_ACTION_ACTIVITIES_LIST_QUERY}
      variables={{
        filter: {
          entityId: entity.id,
          actionType: ['CREATE', 'UPDATE', 'DELETE'],
          entityType: ['IMAGE', 'LINK', 'COMMENT', 'RESOURCE']
        }
      }}
    />
  )
}

export default ActionActivitiesList
